<div class="ks-wrap">

  <!-- Başlık -->
  <div class="ks-baslik-row">
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
         stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
      <rect x="2" y="5" width="20" height="14" rx="2"/>
      <line x1="2" y1="10" x2="22" y2="10"/>
    </svg>
    <span>Kart Sahibi</span>
    <div class="ks-ws-chip" [class.on]="baglimi()">
      <span class="ks-led"></span>
      {{ baglimi() ? 'Bağlı' : 'Bağlanıyor...' }}
    </div>
  </div>

  @if (!kartUid()) {
    <!-- Henüz kart okutulmadı -->
    <div class="ks-bekleme">
      <div class="ks-nfc-animasyon">
        <div class="ks-halka h1"></div>
        <div class="ks-halka h2"></div>
        <div class="ks-halka h3"></div>
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" class="ks-nfc-svg">
          <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1 1 0 011.01-.24c1.12.37 2.33.57 3.57.57a1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1c0 1.25.2 2.45.57 3.57a1 1 0 01-.25 1.02L6.62 10.79z"/>
        </svg>
      </div>
      <div class="ks-bekleme-yazi">Kartı okuyucuya okutun</div>
      <div class="ks-bekleme-alt">Okutulan kart bu widget'a bağlanacak</div>
    </div>
  } @else {
    <!-- Kart okutuldu -->
    <div class="ks-okundu-ozet">
      <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
      <div class="ks-okundu-metin">
        <span class="ks-okundu-baslik">Kart bağlandı</span>
        <span class="ks-okundu-uid">UID: {{ kartUid() }}</span>
      </div>
      <button class="ks-yeniden-btn" (click)="yenidenOkut()">Değiştir</button>
    </div>

    <!-- Sahip ismi + profil resmi -->
    <div class="ks-alan ks-alan-kisi">
      <div class="ks-resim-alan">
        <label class="ks-resim-etiket" [class.ks-resim-yukleniyor]="resimYukleniyor()">
          @if (sahipResimUrl()) {
            <img class="ks-resim-onizleme" [src]="sahipResimUrl()" alt="" />
          } @else {
            <span class="ks-resim-bos">{{ (parametreler()?.ek?.sahipIsmi || '?')[0] }}</span>
          }
          @if (resimYukleniyor()) {
            <span class="ks-resim-spinner"></span>
          }
          <input type="file" accept="image/*" class="ks-resim-input" (change)="resimSecildi($event)" />
        </label>
        @if (sahipResimUrl() && !resimYukleniyor()) {
          <button class="ks-resim-kaldir-btn" type="button" (click)="resimKaldir()">Kaldır</button>
        }
      </div>
      <div class="ks-alan-isim-blok">
        <label class="ks-label">Bu kart kime ait?</label>
        <input class="ks-input"
               placeholder="Ör: Fikri Topaloğlu"
               [ngModel]="parametreler()?.ek?.sahipIsmi || ''"
               (ngModelChange)="guncelle('sahipIsmi', $event)"
               autofocus />
      </div>
    </div>
  }

</div>
